import Shortcut, { type ShortcutProps } from "../shortcut/Shortcut";

/** A key (`"d"`, `{ key: "s", ctrl: true }`), or a two-step shortcut (`{ mainKey, subKey }`). */
export type MenuItemShortcut = ShortcutProps["mainKey"] | Pick<ShortcutProps, "mainKey" | "subKey">;

/** The shortcut trailing an item's label. */
export const ItemShortcut = ({ shortcut }: { shortcut: MenuItemShortcut }) => {
  const keys = typeof shortcut === "object" && "mainKey" in shortcut ? shortcut : { mainKey: shortcut };
  return <Shortcut variant="text" className="ml-auto" {...keys} />;
};
